// extracted by mini-css-extract-plugin
export default {"game":"game_game__MZOMp","ui":"game_ui__Bh2AP","pano":"game_pano__yFll6","minimap":"game_minimap__lggJp","place_point":"game_place_point__Zdivn"};